export const INSPECTION_ACTIONS = {
    INSPECTION_LIST : "INSPECTION_LIST"
}